import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8ae1528a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=8ae1528a&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\lptni\\开发\\dev\\project\\unbox-server\\vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ae1528a')) {
      api.createRecord('8ae1528a', component.options)
    } else {
      api.reload('8ae1528a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8ae1528a", function () {
      api.rerender('8ae1528a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/member/assembly/addCurrency/index.vue"
export default component.exports